/**
 * A list of sanctioned addresses.
 * Any transactions to or from any of these addresses must be rejected by the system.
 * TODO move this into a database, managed by internal dashboard
 */
export const SANCTIONED_ADDRESSES: SanctionedAddress[] = [
  {
    address: '0x8589427373D6D84E98730D7795D8f6f8731FDA16',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0x722122dF12D4e14e13Ac3b6895a86e84145b6967',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0xDD4c48C0B24039969fC16D1cdF626eaB821d3384',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0xd90e2f925DA726b50C4Ed8D0Fb90Ad053324F31b',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0xd96f2B1c14Db8458374d9Aca76E26c3D18364307',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0x4736dCf1b7A3d580672CcE6E7c65cd5cc9cFBa9D',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0xD4B88Df4D29F5CedD6857912842cff3b20C8Cfa3',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0x910Cbd523D972eb0a6f4cAe4618aD62622b39DbF',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0xA160cdAB225685dA1d56aa342Ad8841c3b53f291',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0xFD8610d20aA15b7B2E3Be39B396a1bC3516c7144',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0xF60dD140cFf0706bAE9Cd734Ac3ae76AD9eBC32A',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0x22aaA7720ddd5388A3c0A3333430953C68f1849b',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0xBA214C1c1928a32Bffe790263E38B4Af9bFCD659',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0xb1C8094B234DcE6e03f10a5b673c1d8C69739A00',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0x527653eA119F3E6a1F5BD18fbF4714081D7B31ce',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0x58E8dCC13BE9780fC42E8723D8EaD4CF46943dF2',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0xD691F27f38B395864Ea86CfC7253969B409c362d',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0xaEaaC358560e11f52454D997AAFF2c5731B6f8a6',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0x1356c899D8C9467C7f71C195612F8A395aBf2f0a',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0xA60C772958a3eD56c1F15dD055bA37AC8e523a0D',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0x169AD27A470D064DEDE56a2D3ff727986b15D52B',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0x0836222F2B2B24A3F36f98668Ed8F0B38D1a872f',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0xF67721A2D8F736E75a49FdD7FAd2e31D8676542a',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0x9AD122c22B14202B4490eDAf288FDb3C7cb3ff5E',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0x905b63Fff465B9fFBF41DeA908CEb12478ec7601',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0x07687e702b410Fa43f4cB4Af7FA097918ffD2730',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0x94A1B5CdB22c43faab4AbEb5c74999895464Ddaf',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0xb541fc07bC7619fD4062A54d96268525cBC6FfEF',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0x12D66f87A04A9E220743712cE6d9bB1B5616B8Fc',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0x47CE0C6eD5B0Ce3d3A51fdb1C52DC66a7c3c2936',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0x23773E65ed146A459791799d01336DB287f25334',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0xD21be7248e0197Ee08E0c20D4a96DEBdaC3D20Af',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0x610B717796ad172B316836AC95a2ffad065CeaB4',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0x178169B423a011fff22B9e3F3abeA13414dDD0F1',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0xbB93e510BbCD0B7beb5A853875f9eC60275CF498',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0x2717c5e28cf931547B621a5dddb772Ab6A35B701',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0x03893a7c7463AE47D46bc7f091665f1893656003',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0xCa0840578f57fE71599D29375e16783424023357',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0x58E8dCC13BE9780fC42E8723D8EaD4CF46943dF2',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0x8589427373D6D84E98730D7795D8f6f8731FDA16',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0x722122dF12D4e14e13Ac3b6895a86e84145b6967',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0xDD4c48C0B24039969fC16D1cdF626eaB821d3384',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0xd90e2f925DA726b50C4Ed8D0Fb90Ad053324F31b',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0xd96f2B1c14Db8458374d9Aca76E26c3D18364307',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  },
  {
    address: '0x4736dCf1b7A3d580672CcE6E7c65cd5cc9cFBa9D',
    description:
      'https://home.treasury.gov/policy-issues/financial-sanctions/recent-actions/20220808',
    note: 'tornado cash'
  }
]

/**
 * Check if an address is sanctioned
 *
 * @param address Address to check against sanction list
 * @returns false when address is not on the list. SanctionedAddress object when address is on the list
 */
export const AddressIsSanctioned = (address: string): SanctionedAddress | boolean => {
  const addressLower = address.toLowerCase()
  for (let i = 0; i < SANCTIONED_ADDRESSES.length; i++) {
    if (addressLower === SANCTIONED_ADDRESSES[i].address.toLowerCase()) {
      return SANCTIONED_ADDRESSES[i]
    }
  }
  return false
}

export type SanctionedAddress = {
  address: string
  description: string
  note: string
}
